import type { ReactNode } from "react";
import type { StyleProp, TextStyle } from "react-native";
import { PrimaryTitleText } from "./PrimaryTitleText";

type Props = {
  children: ReactNode;
  numberOfLines?: number;
  style?: StyleProp<TextStyle>;
};

export function CardTitleText({ children, numberOfLines, style }: Props) {
  return (
    <PrimaryTitleText numberOfLines={numberOfLines} style={style}>
      {children}
    </PrimaryTitleText>
  );
}

export default CardTitleText;
